import { render, staticRenderFns } from "./sidetext.vue?vue&type=template&id=63c35d77&scoped=true&"
import script from "./sidetext.vue?vue&type=script&lang=js&"
export * from "./sidetext.vue?vue&type=script&lang=js&"
import style0 from "./sidetext.vue?vue&type=style&index=0&id=63c35d77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c35d77",
  null
  
)

export default component.exports